export default __webpack_public_path__ + "static/media/shop-by-size.1f41e967.png";